import React from "react";
import { pure } from "recompose";

import { isAccepted } from "services/utils";
import Goal from "./Goal";

const PMGoals = pure(({ forecasts, promos, sales }) => (
  <div>
    <Goal name="Price" checked={isAccepted(forecasts)} />
    <Goal name="Promotion" checked={isAccepted(promos)} />
    <Goal name="Sales" checked={isAccepted(sales)} />
  </div>
));

export default PMGoals;



// WEBPACK FOOTER //
// ./src/components/dashboard/PMGoals.js